import { User } from "lucide-react";
import { useI18n } from "@/i18n";
import type { TelegramUser } from "@/tg/auth";

const MOCK_AMOUNT = "7 500 ₴";

interface Props {
  user: TelegramUser | null;
}

export default function MyDonationsBlock({ user }: Props) {
  const { t } = useI18n();

  return (
    <div>
      <div
        style={{
          background: "var(--tint)",
          borderRadius: "var(--r-card)",
          border: "1px solid var(--border)",
          padding: 16,
        }}
      >
        {/* Avatar + support row */}
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          {user?.photo_url ? (
            <img
              src={user.photo_url}
              alt="avatar"
              style={{ width: 48, height: 48, borderRadius: "50%", objectFit: "cover", flexShrink: 0 }}
            />
          ) : (
            <div
              style={{
                width: 48,
                height: 48,
                borderRadius: "50%",
                flexShrink: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "var(--tint)",
                border: "1px solid var(--border)",
              }}
            >
              <User size={24} color="var(--muted)" strokeWidth={1.5} />
            </div>
          )}
          <div>
            <p style={{ fontSize: 13, color: "var(--muted)", margin: 0 }}>
              {t("my_support")}
            </p>
            {/* Support amount — largest number on the page */}
            <p
              style={{
                fontSize: 34,
                fontWeight: 700,
                lineHeight: 1.1,
                color: "var(--brand-blue)",
                margin: "2px 0 0",
              }}
            >
              {MOCK_AMOUNT}
            </p>
          </div>
        </div>
      </div>

      {/* Footnote */}
      <p
        style={{
          textAlign: "center",
          fontSize: 11,
          color: "var(--muted)",
          marginTop: 6,
          marginBottom: 0,
        }}
      >
        {t("demo_data_note")}
      </p>
    </div>
  );
}
